import {Button} from 'antd';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {DoubleMemberApi} from '../../scaffold';
import React from 'react';
export default function SendDoubleMemberSMSBtn(props: {id: number}) {
  const sendSMSHook = useOpenApiFpRequest(DoubleMemberApi, DoubleMemberApi.prototype.doubleMemberSendSMSPost);
  return (
    <Button
      loading={sendSMSHook.loading}
      size={'small'}
      type={'primary'}
      onClick={() => {
        sendSMSHook.requestSync({findParams: {id: props.id}});
      }}>
      发送短信
    </Button>
  );
}
